import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import Calendar from 'react-calendar';
import { Header, Menu } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';

export default observer(function ActivityFilters() {
    const usStore = useStore(); //'.

    return (
        <Fragment>
            <Menu vertical size='large' style={{width: '100%', marginTop: 27 }} >
                <Header icon='filter' attached color='teal' content='Filters' />

                {/* <Menu.Item content='All Activities' /> */}
                <Menu.Item 
                    content='All Activities' 
                    active={usStore.activityStore.predicateMap.has('all')} 
                    onClick={() => usStore.activityStore.setPredicateMap('all', 'true')}
                />

                {/* <Menu.Item content="I'm going" /> */}
                <Menu.Item 
                    content="I'm going"                    
                    active={usStore.activityStore.predicateMap.has('isGoing')} 
                    onClick={() => usStore.activityStore.setPredicateMap('isGoing', 'true')}
                />

                {/* <Menu.Item content="I'm hosting" /> */}
                <Menu.Item 
                    content="I'm hosting"
                    active={usStore.activityStore.predicateMap.has('isHost')} 
                    onClick={() => usStore.activityStore.setPredicateMap('isHost', 'true')}
                />

            </Menu>

            <Header />
            {/* <Calendar /> */}
            <Calendar 
                onChange={(date: any) => usStore.activityStore.setPredicateMap('startDate', date as Date)} 
                value={usStore.activityStore.predicateMap.get('startDate' || new Date())}
            />
            
        </Fragment>
    )
})